import { CodeFieldIncludeInactiveKey } from 'app/area/codetable/types-store';

export const defaultMaxResults = 50;
export const mdResolution = 770;
export const defaultIncludeInactiveCodes = CodeFieldIncludeInactiveKey.active;
export enum CodeDragItemType {
  codeTile = 'CODE_TILE'
}
export const regenerateAggregatedTablesEndpoint = (id: number) => `optionsCollection/${id}/regenerate`;
